import InnerComponent from '@Components/Admin/Inventory';
import orgContainer from '@Components/AppContainer';

const InventoryAdmin = () => ((orgContainer(InnerComponent)));
export default InventoryAdmin;
